export type TierId = 'garage' | 'restorer' | 'pro_shop';

export interface TierFeature {
  text: string;
  dim?: boolean;
}

export interface Tier {
  id: TierId;
  name: string;
  price: number;
  period: string;
  featured?: boolean;
  features: TierFeature[];
}

export const TIERS: readonly Tier[] = [
  {
    id: 'garage',
    name: 'GARAGE',
    price: 29,
    period: 'Single Builder',
    features: [
      { text: 'Browse all pricing & inventory' },
      { text: 'Save up to 3 vehicle profiles' },
      { text: '5 active quotes per month' },
      { text: 'Basic VIN scanner' },
      { text: 'Full SWC Promise included' },
      { text: 'No multi-seat access', dim: true },
    ],
  },
  {
    id: 'restorer',
    name: 'RESTORER',
    price: 99,
    period: 'Active Project',
    featured: true,
    features: [
      { text: 'Unlimited quotes' },
      { text: 'Unlimited vehicle profiles' },
      { text: 'Priority email + tech line' },
      { text: 'AI alerts on new arrivals' },
      { text: '"Source It" requests included' },
      { text: 'Branded PDF exports' },
    ],
  },
  {
    id: 'pro_shop',
    name: 'PRO SHOP',
    price: 249,
    period: 'Multi-Bay Operation',
    features: [
      { text: 'Everything in Restorer' },
      { text: 'Up to 5 user seats' },
      { text: 'Co-branded PDFs (your logo)' },
      { text: 'Priority "Source It" sourcing' },
      { text: 'Monthly market intelligence brief' },
      { text: 'Direct line to founder' },
    ],
  },
] as const;
